import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import { toInteger } from 'lodash';

export const interestsApi = createApi({
  reducerPath: 'interestsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    // Endpoint pre vrátenie záujmu študenta podľa ID
    getInterest: builder.query({
      query(id) {
        return {
          url: urls.fijInterestsDetail(id),
          method: 'GET',
        };
      },
    }),
    // Endpoint pre vrátenie všetkých záujmov prihláseného študenta
    getMyInterests: builder.query({
      query() {
        return {
          url: urls.fijMyInterests,
          method: 'GET',
        };
      },
    }),
    // Endpoint pre vytvorenie nového záujmu študenta
    createInterest: builder.mutation({
      query(req) {
        req.body.internal_job_id = toInteger(req.id);
        return {
          url: urls.fijCreateInterest,
          method: 'POST',
          data: req.body,
        };
      },
    }),
    // Endpoint pre aktualizáciu záujmu študenta
    updateInterest: builder.mutation({
      query(req) {
        return {
          url: urls.fijUpdateInterest(req.id),
          method: 'PUT',
          data: req.body,
        };
      },
    }),
    // Endpoint pre vymazanie záujmu študenta
    deleteInterest: builder.mutation({
      query(id) {
        return {
          url: urls.fijInterestsDetail(id),
          method: 'DELETE',
        };
      },
    }),
    // Endpoint pre priradenie študenta na prax
    acceptInterest: builder.mutation({
      query(interestId) {
        return {
          url: urls.fijAcceptInterest(interestId),
          method: 'POST',
        };
      },
    }),
    // Endpoint pre odmietnutie študenta
    rejectInterest: builder.mutation({
      query(req) {
        req.interestId = toInteger(req.interestId);

        return {
          url: urls.fijRejectInterest(req.interestId),
          method: 'POST',
          data: {
            reason: req.reason,
          },
        };
      },
    }),
    // Endpoint pre nastavenie, že študent neúspešne ukončil prax
    finishUnsuccessfully: builder.mutation({
      query(interestId) {
        return {
          url: urls.fijStudentFailed(interestId),
          method: 'POST',
        };
      },
    }),
    // Endpoint pre nastavenie, že študent úspešne ukončil prax
    finishSuccessfully: builder.mutation({
      query(req) {
        req.interestId = toInteger(req.interestId);
        req.hours_worked = toInteger(req.hours_worked);

        return {
          url: urls.fijStudentSucceeded(req.interestId),
          method: 'POST',
          data: {
            hours_worked: req.hours_worked,
          },
        };
      },
    }),
  }),
});

export const {
  useGetInterestQuery,
  useCreateInterestMutation,
  useUpdateInterestMutation,
  useGetMyInterestsQuery,
  useAcceptInterestMutation,
  useRejectInterestMutation,
  useFinishUnsuccessfullyMutation,
  useFinishSuccessfullyMutation,
  useDeleteInterestMutation,
} = interestsApi;
